/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetEmbeddingsUsageRequest = {
  startTime: number;
  endTime?: number | undefined;
  bucketWidth?: components.BucketWidth | undefined;
  limit?: number | undefined;
  page?: string | undefined;
  userIds?: Array<string> | undefined;
  externalUserIds?: Array<string> | undefined;
  allOrgs?: string | undefined;
  orgIds?: Array<string> | undefined;
  groupBy?: Array<components.EmbeddingsGroupBy> | undefined;
  models?: Array<string> | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

export type GetEmbeddingsUsageData = {
  object: "bucket";
  /**
   * Unix timestamp of bucket start (inclusive)
   */
  startTime: number;
  /**
   * Unix timestamp of bucket end (exclusive)
   */
  endTime: number;
  /**
   * Array of usage results for this time bucket
   */
  results: Array<any | null>;
};

/**
 * OK
 */
export type GetEmbeddingsUsageResponseBody = {
  object: "page";
  data: Array<GetEmbeddingsUsageData>;
  /**
   * Whether there are more pages
   */
  hasMore: boolean;
  /**
   * Cursor for next page, null if no more pages
   */
  nextPage: string | null;
};

/** @internal */
export const GetEmbeddingsUsageRequest$inboundSchema: z.ZodType<
  GetEmbeddingsUsageRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  start_time: z.number().int(),
  end_time: z.number().int().optional(),
  bucket_width: components.BucketWidth$inboundSchema.default("1d"),
  limit: z.number().int().optional(),
  page: z.string().optional(),
  user_ids: z.array(z.string()).optional(),
  external_user_ids: z.array(z.string()).optional(),
  all_orgs: z.string().optional(),
  org_ids: z.array(z.string()).optional(),
  group_by: z.array(components.EmbeddingsGroupBy$inboundSchema).optional(),
  models: z.array(z.string()).optional(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "start_time": "startTime",
    "end_time": "endTime",
    "bucket_width": "bucketWidth",
    "user_ids": "userIds",
    "external_user_ids": "externalUserIds",
    "all_orgs": "allOrgs",
    "org_ids": "orgIds",
    "group_by": "groupBy",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetEmbeddingsUsageRequest$Outbound = {
  start_time: number;
  end_time?: number | undefined;
  bucket_width: string;
  limit?: number | undefined;
  page?: string | undefined;
  user_ids?: Array<string> | undefined;
  external_user_ids?: Array<string> | undefined;
  all_orgs?: string | undefined;
  org_ids?: Array<string> | undefined;
  group_by?: Array<string> | undefined;
  models?: Array<string> | undefined;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetEmbeddingsUsageRequest$outboundSchema: z.ZodType<
  GetEmbeddingsUsageRequest$Outbound,
  z.ZodTypeDef,
  GetEmbeddingsUsageRequest
> = z.object({
  startTime: z.number().int(),
  endTime: z.number().int().optional(),
  bucketWidth: components.BucketWidth$outboundSchema.default("1d"),
  limit: z.number().int().optional(),
  page: z.string().optional(),
  userIds: z.array(z.string()).optional(),
  externalUserIds: z.array(z.string()).optional(),
  allOrgs: z.string().optional(),
  orgIds: z.array(z.string()).optional(),
  groupBy: z.array(components.EmbeddingsGroupBy$outboundSchema).optional(),
  models: z.array(z.string()).optional(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    startTime: "start_time",
    endTime: "end_time",
    bucketWidth: "bucket_width",
    userIds: "user_ids",
    externalUserIds: "external_user_ids",
    allOrgs: "all_orgs",
    orgIds: "org_ids",
    groupBy: "group_by",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getEmbeddingsUsageRequestToJSON(
  getEmbeddingsUsageRequest: GetEmbeddingsUsageRequest,
): string {
  return JSON.stringify(
    GetEmbeddingsUsageRequest$outboundSchema.parse(getEmbeddingsUsageRequest),
  );
}
export function getEmbeddingsUsageRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetEmbeddingsUsageRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetEmbeddingsUsageRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetEmbeddingsUsageRequest' from JSON`,
  );
}

/** @internal */
export const GetEmbeddingsUsageData$inboundSchema: z.ZodType<
  GetEmbeddingsUsageData,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("bucket"),
  start_time: z.number().int(),
  end_time: z.number().int(),
  results: z.array(z.nullable(z.any())),
}).transform((v) => {
  return remap$(v, {
    "start_time": "startTime",
    "end_time": "endTime",
  });
});
/** @internal */
export type GetEmbeddingsUsageData$Outbound = {
  object: "bucket";
  start_time: number;
  end_time: number;
  results: Array<any | null>;
};

/** @internal */
export const GetEmbeddingsUsageData$outboundSchema: z.ZodType<
  GetEmbeddingsUsageData$Outbound,
  z.ZodTypeDef,
  GetEmbeddingsUsageData
> = z.object({
  object: z.literal("bucket"),
  startTime: z.number().int(),
  endTime: z.number().int(),
  results: z.array(z.nullable(z.any())),
}).transform((v) => {
  return remap$(v, {
    startTime: "start_time",
    endTime: "end_time",
  });
});

export function getEmbeddingsUsageDataToJSON(
  getEmbeddingsUsageData: GetEmbeddingsUsageData,
): string {
  return JSON.stringify(
    GetEmbeddingsUsageData$outboundSchema.parse(getEmbeddingsUsageData),
  );
}
export function getEmbeddingsUsageDataFromJSON(
  jsonString: string,
): SafeParseResult<GetEmbeddingsUsageData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetEmbeddingsUsageData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetEmbeddingsUsageData' from JSON`,
  );
}

/** @internal */
export const GetEmbeddingsUsageResponseBody$inboundSchema: z.ZodType<
  GetEmbeddingsUsageResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("page"),
  data: z.array(z.lazy(() => GetEmbeddingsUsageData$inboundSchema)),
  has_more: z.boolean(),
  next_page: z.nullable(z.string()),
}).transform((v) => {
  return remap$(v, {
    "has_more": "hasMore",
    "next_page": "nextPage",
  });
});
/** @internal */
export type GetEmbeddingsUsageResponseBody$Outbound = {
  object: "page";
  data: Array<GetEmbeddingsUsageData$Outbound>;
  has_more: boolean;
  next_page: string | null;
};

/** @internal */
export const GetEmbeddingsUsageResponseBody$outboundSchema: z.ZodType<
  GetEmbeddingsUsageResponseBody$Outbound,
  z.ZodTypeDef,
  GetEmbeddingsUsageResponseBody
> = z.object({
  object: z.literal("page"),
  data: z.array(z.lazy(() => GetEmbeddingsUsageData$outboundSchema)),
  hasMore: z.boolean(),
  nextPage: z.nullable(z.string()),
}).transform((v) => {
  return remap$(v, {
    hasMore: "has_more",
    nextPage: "next_page",
  });
});

export function getEmbeddingsUsageResponseBodyToJSON(
  getEmbeddingsUsageResponseBody: GetEmbeddingsUsageResponseBody,
): string {
  return JSON.stringify(
    GetEmbeddingsUsageResponseBody$outboundSchema.parse(
      getEmbeddingsUsageResponseBody,
    ),
  );
}
export function getEmbeddingsUsageResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<GetEmbeddingsUsageResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetEmbeddingsUsageResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetEmbeddingsUsageResponseBody' from JSON`,
  );
}
